import { useState, useEffect } from "react";
import { X, RefreshCw } from "lucide-react";

const STORAGE_KEY = "gtpa_dismissed_version";
const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION || "";

interface UpdateBannerProps {
  onVisibilityChange?: (visible: boolean) => void;
}

export default function UpdateBanner({ onVisibilityChange }: UpdateBannerProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!BUILD_VERSION) return;

    const dismissedVersion = localStorage.getItem(STORAGE_KEY);
    const shouldShow = dismissedVersion !== BUILD_VERSION;
    setIsVisible(shouldShow);
    onVisibilityChange?.(shouldShow);
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, BUILD_VERSION);
    setIsVisible(false);
    onVisibilityChange?.(false);
  };

  const handleRefresh = () => {
    localStorage.setItem(STORAGE_KEY, BUILD_VERSION);
    // 강력 새로고침: 캐시 버스팅 쿼리 파라미터 추가
    const url = new URL(window.location.href);
    url.searchParams.set("_refresh", Date.now().toString());
    window.location.href = url.toString();
  };

  if (!isVisible) return null;

  return (
    <div
      className="text-white px-4 py-2 flex items-center justify-center gap-3 relative z-50"
      style={{ backgroundColor: "#A76D6E" }}
    >
      <RefreshCw className="w-4 h-4" />
      <span className="text-sm font-medium">
        사이트가 업데이트되었습니다. 최신 버전을 사용하려면{" "}
        <button
          onClick={handleRefresh}
          className="underline font-semibold hover:opacity-80"
        >
          여기를 클릭
        </button>
        해주세요.
      </span>
      <button
        onClick={handleDismiss}
        className="absolute right-4 hover:opacity-80"
        aria-label="닫기"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
